import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCirclePlaceholderOff: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCirclePlaceholderOff"><Path d="M6.84624 4.01812C8.33076 3.05762 10.1003 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12C21.5 13.8997 20.9424 15.6692 19.9819 17.1538M3.25 3.25L20.75 20.75M5.07176 5.5C3.47685 7.19931 2.5 9.48558 2.5 12C2.5 17.2467 6.75329 21.5 12 21.5C14.5144 21.5 16.8007 20.5231 18.5 18.9282" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCirclePlaceholderOff;
